import { Box } from '@mui/system';

interface TabPanelProps {
	children?: React.ReactNode;
	index: number;
	value: number;
}

const TabPanel = (props: TabPanelProps) => {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
			className="h-[90%]"
		>
			{value === index && (
				<Box
					className="h-full overflow-x-scroll overflow-y-scroll custom-scrollbar"
					sx={{ px: 1 }}
				>
					<div className="flex h-full w-full">{children}</div>
				</Box>
			)}
		</div>
	);
};

export default TabPanel;
